<template>
    <div id="services-lab-hosp-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">
                <div class="row scr-gap-15-0">
                    <div class="col-12 col-md-6 col-xl-6">
                        <select v-model="servLab.roles_id" data-select="on" class="required" data-name-input="Plan">
                            <option :value="0">Selecciona un Proveedor</option>
                            <option :value="3">Ambulancias</option>
                            <option :value="4">Especialista</option>
                            <option :value="11">Dentistas</option>
                            <option :value="7">Institución</option>
                            <option :value="10">Laboratorio</option>
                            <option :value="13">Opticas</option>
                            <option :value="12">Radiología</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 col-xl-6">
                        <select v-model="servLab.status" data-select="on" class="required"
                                data-name-input="Selecciona un Status">
                            <option :value="0">Selecciona un Status</option>
                            <option :value="1">Activo</option>
                            <option :value="2">Inactivo</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 col-xl-12">
                        <input type="text" class="al-inputs required scr-input" placeholder="Nombre de la prueba"
                               v-model="servLab.prueba" id="ap"/>
                        <label for="ap" class="scr-supertext scr-extra">Nombre de la prueba</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-12">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view ">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-3 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-5 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 mb-3 mb-sm-0">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">Agregar</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :filter="filter" :busy="isBusy"
                                 :items="pagination.data" show-empty :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
                            <template #empty="scope">
                                <h4 class="emptyRow">
                                    No hay datos para mostrar.
                                </h4>
                            </template>
                            <template #cell(Prueba)="{item}">
                                <span>{{ item.prueba }}</span>
                            </template>
                            <template #cell(Proveedor)="{item}">
                    <span v-if="item.roles_id===3" class="badge rounded-pill text-bg-warning">{{
                            item.relrole[0].name
                        }}</span>
                                <span v-if="item.roles_id===4" class="badge rounded-pill text-bg-indigo">{{
                                        item.relrole[0].name
                                    }}</span>
                                <span v-if="item.roles_id===7" class="badge rounded-pill text-bg-primary">{{
                                        item.relrole[0].name
                                    }}</span>
                                <span v-if="item.roles_id===10" class="badge rounded-pill text-bg-secondary">{{
                                        item.relrole[0].name
                                    }}</span>
                                <span v-if="item.roles_id===11" class="badge rounded-pill text-bg-purple">{{
                                        item.relrole[0].name
                                    }}</span>
                                <span v-if="item.roles_id===12" class="badge rounded-pill text-bg-cyan">{{
                                        item.relrole[0].name
                                    }}</span>
                                <span v-if="item.roles_id===13" class="badge rounded-pill text-bg-info">{{
                                        item.relrole[0].name
                                    }}</span>
                            </template>
                            <template #cell(Status)="{item}">
                                <span v-if="item.status===2" class="badge rounded-pill text-bg-danger">Inactivo</span>
                                <span v-else class="badge rounded-pill text-bg-success">Activo</span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true;updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                        </b-table>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {testlabhospService} from "../../Services/Testlabhosp.service";

export default {
    name: "services-lab-hosp",
    mixins: [myMixins],
    data() {
        return {
            filter: null,
            sortBy: 'Paquete',
            sortDesc: false,
            modificar: false,
            isBusy: false,
            tituloBtn: "Guardar",
            servLab: {
                roles_id: 0,
                prueba: "",
                status: 0,
                id: '',
            },
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            fields: [
                {key: "Prueba", sortable: true},
                {key: "Proveedor"},
                {key: "Status"},
                {key: "Acciones"}
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
        };
    },
    methods: {
        updateReg(item) {
            //console.log(item);
            this.servLab = item;
            this.tituloBtn = "Actualizar";
            this.modificar = true;
        },
        async index() {
            //console.log(this.params);
            this.isBusy = true;
            this.pagination = await testlabhospService.getMany(this.params);
            this.isBusy = false;
        },
        async onClickDelete(id) {
            let resp = await testlabhospService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {

            let resp = '';
            let respVal = this.valFormulariosV3();

            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await testlabhospService.updateOne(this.servLab.id, this.servLab);
                } else {
                    resp = await testlabhospService.saveOne(this.servLab);
                }
                this.disableSubmitBtn(false);
            }

            if (resp.process === 'success') {
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
            } else {
                this.getAlert(resp.process);
            }
            this.modificar = false;
        },
        async onChange(page) {
            this.params.page = page;
            await this.index();
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.servLab = {
                roles_id: 0,
                prueba: "",
                status: 0,
                id: '',
            }
        }
    },
    mounted() {
        this.index();
    },
}
</script>

